module.exports = __webpack_public_path__ + "img/scenario-move.f31a13c.svg";